import React, { Component } from 'react';
import image from '../../assets/img/vector/soporte.svg';
import image2 from '../../assets/img/contenido/soporte.png';
import Section from '../../layout/Section';
import SectionContainer from '../../subcomponents/SectionContainer';

import ImageText from '../../subcomponents/ImageText';
import TextImage from '../../subcomponents/TextImage';
import img1 from '../../assets/img/flat/soporte1.svg';
import img2 from '../../assets/img/flat/soporte2.svg';
import img3 from '../../assets/img/flat/soporte3.svg';
import IconBlock from '../../subcomponents/IconBlock28';

class SoporteIntegral extends Component {
  componentDidMount() {
    document.title = 'Soporte Integral - Insacom';
  }

  render() {
    const content = [
      {
        id: 1,
        title: 'Soporte Integral',
        description: 'Todas nuestras áreas de especialistas apoyan a la continuidad operativa',
        img: img1
      },
      {
        id: 2,
        title: 'Mantenciones Preventivas',
        description: 'Asesoría para detección temprana de problemas',
        img: img2
      },
      {
        id: 3,
        title: 'Reparación de Equipos',
        description: 'Cientos de equipos bajo nuestro cuidado desde hace más de 10 años',
        img: img3
      }
    ];

    const descripcion =
      'Somos el primer punto de contacto en la solución a los problemas del día a día para que te preocupes de lo importante. Considerando tanto aspectos físicos como lógicos, prevenimos problemas que puedan afectar la continuidad operativa de tu empresa.';

    return (
      <Section asuntoContacto={'Soporte Integral'}>
        <SectionContainer>
          <ImageText image={image} title="Soporte Integral" description={descripcion}></ImageText>
        </SectionContainer>
        <SectionContainer grey>
          <IconBlock version={1} content={content}></IconBlock>
        </SectionContainer>
        <SectionContainer>
          <TextImage image={image2} title="Características">
            <ul className="list-unstyled mb-0">
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Distintos niveles de soporte para atender sus requerimientos.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Trabajos preventivos regulares para mantener excelentes niveles de servicio.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Asesoría para detección temprana de problemas.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Cientos de equipos bajo nuestro cuidado desde hace más de 9 años.
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Outsourcing de Servicios TI
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Atención personalizada
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Asistencia remota y presencial
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Personal experto
                </p>
              </li>
              <li>
                <p className="mb-3">
                  <i className="d-inline-block g-color-primary mr-2 fa fa-check"></i>
                  Asesoramiento permanente
                </p>
              </li>
            </ul>
          </TextImage>
        </SectionContainer>
      </Section>
    );
  }
}

export default SoporteIntegral;



// WEBPACK FOOTER //
// ./src/sections/ti/SoporteIntegral.js